import React, {
  useState,
  useEffect,
  useCallback,
}             from 'react';
import useJwt from "hooks/useJwt";
import {
  FormattedMessage,
  useIntl,
}             from 'react-intl';

const WEB_CLIENT_BASE_URL = process.env.MAPP_WEB_CLIENT_BASE_URL;

const Register = () => {

  const { formatMessage } = useIntl();

  const FIELDS = [
    {
      formatted: formatMessage({ defaultMessage: 'Nombre' }),
      name: 'first_name',
    },
    {
      formatted: formatMessage({ defaultMessage: 'Apellido' }),
      name: 'last_name',
    },
    {
      formatted: formatMessage({ defaultMessage: 'Email' }),
      name: 'email',
    },
    {
      formatted: formatMessage({ defaultMessage: 'Contraseña' }),
      name: 'password',
    },
  ];

  const [form, setForm] = useState(FIELDS.reduce((acc, { name }) => ({ ...acc, [name]: '' }), {}));
  const { invitation_token } = window.location.search && window
    .location
    .search
    .slice(1)
    .split('&')
    .map(i => i.split('='))
    .map(([k, v]) => ({ [k]: v }))
    .reduce((p, c) => Object.assign({}, p, c), {});

  const { decoded_token, is_expired } = useJwt(invitation_token);

  const { email } = form;
  const { email: token_email } = decoded_token;

  const onRegister = useCallback(() => {
    fetch(`${WEB_CLIENT_BASE_URL}register/${invitation_token}`, {
      method: "POST",
      headers: {
        ['Content-Type']: 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(form),
    });
  }, [form, invitation_token]);

  useEffect(() => {
    const onEnter = e => {
      if (e.key === 'Enter') {
        e.stopPropagation();
        onRegister();
      }
    };

    window.addEventListener('keydown', onEnter);
    return () => window.removeEventListener('keydown', onEnter);
  }, [onRegister]);

  useEffect(() => {
    if (decoded_token && email !== token_email) {
      setForm(form => ({
        ...form,
        email: token_email,
      }));
    }
  }, [decoded_token, email, token_email]);

  if (is_expired) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1em',
        }}
      >
        <h1 style={{ fontSize: Fonts.size.texas_large }}>
          <FormattedMessage defaultMessage='Bienvenido a Walcu' />
        </h1>
        <div>
          <FormattedMessage defaultMessage='El link de invitacion ha expirado. Contacta con tu administrador para que te dé uno nuevo' />
        </div>
      </div>
    );
  }

  return (
    <>
      <h1
        style={{
          fontSize: Fonts.size.texas_large,
        }}
      >
        <FormattedMessage defaultMessage='Bienvenido a Walcu' />
      </h1>
      {FIELDS.map(({ name, formatted }) => (
        <div
          key={name}
          style={{
            width: '30%',
            minWidth: '15em',
          }}
        >
          <label style={{ fontWeight: Fonts.weight.bold }}>
            {formatted}
          </label>
          <input
            value={form[name]}
            onChange={e => setForm({ ...form, [name]: e.target.value })}
            className="input"
            type={name === 'password' ? 'password' : 'text'}
            disabled={name === 'email'}
          />
        </div>
      ))}
      <button
        className="button-medium button-primary"
        onClick={onRegister}
      >
        Regístrate en Walcu
      </button>
    </>
  );
};

export default Register;
